import { render, staticRenderFns } from "./MaterialDistributionDetails.vue?vue&type=template&id=7325e795&scoped=true"
import script from "./MaterialDistributionDetails.vue?vue&type=script&lang=js"
export * from "./MaterialDistributionDetails.vue?vue&type=script&lang=js"
import style0 from "./MaterialDistributionDetails.vue?vue&type=style&index=0&id=7325e795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7325e795",
  null
  
)

export default component.exports